/* eslint-disable */
import { mode } from '@chakra-ui/theme-tools';

const titleBaseStyles = (props) => ({
  fontWeight: '600',
  fontStyle: 'normal',
  color: mode('#0E1633', 'white')(props),
});

const textBaseStyles = (props) => ({
  fontWeight: '400',
  fontStyle: 'normal',
  lineHeight: 'normal',
  color: mode('#262D47', '#E1E1E1')(props),
});

const linkBaseStyles = (props) => ({
  fontWeight: '400',
  fontStyle: 'normal',
  lineHeight: 'normal',
  transition: '0.2s all',
  color: mode('#0E1633', 'white')(props),
  _hover: {
    color: mode('#0497FD', '#0497FD')(props),
  }
});

export const textStyles = {
  components: {
    Text: {
      baseStyle: (props) => ({
        ...textBaseStyles(props),
        fontSize: '16px',
      }),
      variants: {
        'title-lg': (props) => ({
          ...titleBaseStyles(props),
          fontSize: '18px',
        }),
        'title-md': (props) => ({
          ...titleBaseStyles(props),
          fontSize: '16px',
        }),
        'title-sm': (props) => ({
          ...titleBaseStyles(props),
          fontSize: '14px',
        }),
        'text-lg': (props) => ({
          ...textBaseStyles(props),
          fontSize: '18px',
        }),
        'text-md': (props) => ({
          ...textBaseStyles(props),
          fontSize: '16px',
        }),
        'text-sm': (props) => ({
          ...textBaseStyles(props),
          fontSize: '14px',
        }),
        'text-xs': (props) => ({
          ...textBaseStyles(props),
          fontSize: '12px',
          letterSpacing: '-0.4px'
        }),
        /* Links */
        'link-lg': (props) => ({
          ...linkBaseStyles(props),
          fontSize: '18px',
        }),
        'link-md': (props) => ({
          ...linkBaseStyles(props),
          fontSize: '16px',
        }),
        'link-sm': (props) => ({
          ...linkBaseStyles(props),
          fontSize: '14px',
        }),
        'link-xs': (props) => ({
          ...linkBaseStyles(props),
          fontSize: '12px',
          letterSpacing: '-0.4px'
        }),
        /* Header */
        'header': (props) => ({
          ...titleBaseStyles(props),
          fontFeatureSettings: "'liga' off, 'clig' off",
          fontSize: '72px',
          fontStyle: 'italic',
          fontWeight: '900',
          lineHeight: '120%',
          letterSpacing: '-1px',
          textTransform: 'uppercase'
        }),
        'header-gradient': (props) => ({
          ...titleBaseStyles(props),
          fontFeatureSettings: "'liga' off, 'clig' off",
          fontSize: '128px',
          fontStyle: 'italic',
          fontWeight: '900',
          lineHeight: '100%',
          letterSpacing: '-1px',
          textTransform: 'uppercase',
          background: 'linear-gradient(180deg, #2ABDFD 0%, #0497FD 100%)',
          backgroundClip: 'text',
          '-webkit-background-clip': 'text',
          '-webkit-text-fill-color': 'transparent',
          position: 'relative'
        })
      },
    },
  },
};
